import { initialState } from '../initial-state';

export function clearSnapSiteConfig() {
  return initialState;
}
